export default "__VITE_ASSET__Dz30uYtB__"